module.exports = {"TXTWCL_This_event_has_now_finishedX":{"id":"TXTWCL_This_event_has_now_finishedX","defaultMessage":"Cet événement est maintenant terminé."}}